import { Helper } from './Helper';
import { MenuNode } from './MenuNode';
export class Programs {
	static chimneySweepStart: number;
	static chimneySweepDynamicRuns = 0;
	static chimneySweepState = 'stopped';
	static chimneySweepDynamic(t: any) {
		Programs.chimneySweepDynamicRuns++;
		console.log("Program running: " + Programs.chimneySweepDynamicRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		if (Programs.chimneySweepState == 'stopped') {
			Programs.chimneySweepState = 'running';
			let date = new Date();
			Programs.chimneySweepStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			this.value = this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getCurrentValue().toFixed(1);
			this.unit = this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getUnit();
			this.showIconBar = true;
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.chimneySweepStart;
				this.dashIcon = 'iconChimneySweep';
				this.title = this.translator.tr('DELIGHT_MAIN_MENU_ENTRY_CHIMNEY_SWEEPER');
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					t.ioService.deviceInfo().setBurner('active');
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.chimneySweepState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.chimneySweepStart;
				Programs.chimneySweepStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						t.ioService.deviceInfo().setBurner('inactive');
						Programs.chimneySweepState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}

	static automaticWaterFillStart: number;
	static automaticWaterFillRuns = 0;
	static automaticWaterFillState = 'stopped';
	static automaticWaterFill(t: any) {
		Programs.automaticWaterFillRuns++;
		console.log("Program running: " + Programs.automaticWaterFillRuns);
		let getTitle = t.getSubtitle;
		let eH = t.eventHandler;
		let gT = t.getTitle;

		if (Programs.automaticWaterFillState == 'stopped') {
			Programs.automaticWaterFillState = 'running';
			let date = new Date();
			Programs.automaticWaterFillStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getSubtitle = function () {

			this.dashIcon = '';

			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.automaticWaterFillStart;

			if (diff < duration) {
				return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
			}

			if (diff >= duration && (diff - 1000) <= (duration)) {
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";
			}
			if (diff > duration) {
				Programs.automaticWaterFillState = 'stopped';
				this.menuService.goto(this.node.getTargetNode());
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.automaticWaterFillStart;
				Programs.automaticWaterFillStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.automaticWaterFillState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);

			} else {
				eH.call(t, evt);
			}
		}
	}



	static chimneySweepMaxDHWStart: number;
	static chimneySweepMaxDHWRuns = 0;
	static chimneySweepMaxDHWState = 'stopped';
	static chimneySweeepMaxDHW(t: any) {
		Programs.chimneySweepMaxDHWRuns++;
		console.log("Program running: " + Programs.chimneySweepMaxDHWRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		if (Programs.chimneySweepMaxDHWState == 'stopped') {
			Programs.chimneySweepMaxDHWState = 'running';
			let date = new Date();
			Programs.chimneySweepMaxDHWStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		//let scale = t.ioService.deviceInfo().getScale('d077');
		//let d77Val = scale.getCurrentValue();
		//let max = scale.getMaxValue();
		//scale.setCurrentValue(max);


		t.getText = function (idx: number) {
			this.showIconBar = true;
			this.value = this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getCurrentValue().toFixed(1);
			this.unit = this.ioService.deviceInfo().getHeatingCircuit(1).getScale('vorlaufisttemp').getUnit();

			this.title = this.translator.tr('DELIGHT_CHIMNEY_MENU_TITLE');
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.chimneySweepMaxDHWStart;
				this.dashIcon = 'iconChimneySweep';
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					t.ioService.deviceInfo().setBurner('active');
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.chimneySweepMaxDHWState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.chimneySweepMaxDHWStart;
				Programs.chimneySweepMaxDHWStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						t.ioService.deviceInfo().setBurner('inactive');
						Programs.chimneySweepState = 'stopped';
						eH.call(t, 'back');
						//scale.setCurrentValue(d77Val);
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static PurgeProgrammeStart: number;
	static PurgeProgrammeRuns = 0;
	static PurgeProgrammeState = 'stopped';
	static PurgeProgramme(t: any) {
		Programs.PurgeProgrammeRuns++;
		console.log("Program running: " + Programs.PurgeProgrammeRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.PurgeProgrammeState == 'stopped') {
			Programs.PurgeProgrammeState = 'running';
			let date = new Date();
			Programs.PurgeProgrammeStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.00 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_AIRVENT');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_AIRVENT_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.PurgeProgrammeStart;
				this.unit = "bar";
				this.value = "1.2";
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.PurgeProgrammeState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.PurgeProgrammeStart;
				Programs.PurgeProgrammeStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.PurgeProgrammeState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}


	static FillWaterProgramStart: number;
	static FillWaterProgramRuns = 0;
	static FillWaterProgramState = 'stopped';
	static FillWaterProgram(t: any) {
		Programs.FillWaterProgramRuns++;
		console.log("Program running: " + Programs.FillWaterProgramRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.FillWaterProgramState == 'stopped') {
			Programs.FillWaterProgramState = 'running';
			let date = new Date();
			Programs.FillWaterProgramStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.08 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_FILLING_WATER');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.FillWaterProgramStart;
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_FILLING_WATER_DESCRIPTION');
			}
			if (idx == 2) {
				if (diff >= duration) {
					return '';
				} else {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
				}
			}
			if (idx == 1) {

				this.unit = "bar";
				this.value = "1.2";
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.FillWaterProgramState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.FillWaterProgramStart;
				Programs.FillWaterProgramStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.FillWaterProgramState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static P21SupportIgnitionStart: number;
	static P21SupportIgnitionRuns = 0;
	static P21SupportIgnitionState = 'stopped';
	static P21SupportIgnition(t: any) {
		Programs.P21SupportIgnitionRuns++;
		console.log("Program running: " + Programs.P21SupportIgnitionRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;

		t.largeUnit = true;
		if (Programs.P21SupportIgnitionState == 'stopped') {
			Programs.P21SupportIgnitionState = 'running';
			let date = new Date();
			Programs.P21SupportIgnitionStart = parseInt("" + date.getTime());
		}

		let duration = 3 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.21 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_DIAGNOSTIC_SUPPORT_IGNITION');
			this.showIconBar = true;

			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.P21SupportIgnitionStart;
			if (idx == 0) {
				if (diff < 500) {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_DIAGNOSTIC_SUPPORT_IGNITION_DESCRIPTION');
				}
				if (diff > 500 && diff < 1000) {
					t.ioService.deviceInfo().setBurner('active');
					return this.translator.tr('DELIGHT_TEST_PROGRAM_DIAGNOSTIC_SUPPORT_IGNITION_SPECIAL_DESCRIPTION');
				}
				if (diff > 1000) {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_DIAGNOSTIC_SUPPORT_IGNITION_LEGACY_DESCRIPTION');
				}
			}
			if (idx == 2) {
				if (diff >= duration) {
					return '';
				} else {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
				}
			}
			if (idx == 1) {

				this.unit = this.translator.tr('STD_UNIT_CELSIUS_NORMAL_LEFT');
				this.value = "60";
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.P21SupportIgnitionState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.P21SupportIgnitionStart;
				Programs.P21SupportIgnitionStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						t.ioService.deviceInfo().setBurner('inactive');
						Programs.P21SupportIgnitionState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static P22IgnitionEnrichmentStart: number;
	static P22IgnitionEnrichmentRuns = 0;
	static P22IgnitionEnrichmentState = 'stopped';
	static P22IgnitionEnrichment(t: any) {
		Programs.P22IgnitionEnrichmentRuns++;
		console.log("Program running: " + Programs.P22IgnitionEnrichmentRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;

		t.largeUnit = true;
		if (Programs.P22IgnitionEnrichmentState == 'stopped') {
			Programs.P22IgnitionEnrichmentState = 'running';
			let date = new Date();
			Programs.P22IgnitionEnrichmentStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.22 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_IGNITION_ENRICHMENT');
			this.showIconBar = true;

			this.menuIcon = 'iconInstallerGrey';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.P22IgnitionEnrichmentStart;
			if (idx == 0) {
				if (diff < 500) {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_IGNITION_ENRICHMENT_DESCRIPTION');
				}
				if (diff > 500 && diff < 1000) {
					t.ioService.deviceInfo().setBurner('active');
					return this.translator.tr('DELIGHT_TEST_PROGRAM_IGNITION_ENRICHMENT_DESCRIPTION');
				}
				if (diff > 1000) {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_IGNITION_ENRICHMENT_DESCRIPTION');
				}
			}
			if (idx == 2) {
				if (diff >= duration) {
					return '';
				} else {
					return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
				}
			}
			if (idx == 1) {

				this.unit = this.translator.tr('STD_UNIT_CELSIUS_NORMAL_LEFT');
				this.value = "13.5";
				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.P22IgnitionEnrichmentState = 'stopped';
				t.eventHandler('back');
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.P22IgnitionEnrichmentStart;
				Programs.P22IgnitionEnrichmentStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						t.ioService.deviceInfo().setBurner('inactive');
						Programs.P22IgnitionEnrichmentState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static AdjustableLoadProgramStart: number;
	static AdjustableLoadProgramRuns = 0;
	static AdjustableLoadProgramState = 'stopped';
	static AdjustableLoadProgram(t: any) {
		Programs.AdjustableLoadProgramRuns++;
		console.log("Program running: " + Programs.AdjustableLoadProgramRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.AdjustableLoadProgramState == 'stopped') {
			Programs.AdjustableLoadProgramState = 'running';
			let date = new Date();
			Programs.AdjustableLoadProgramStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.01 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_ADJUSTABLE_POWER_LOAD');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let scale = this.ioService.getDeviceInfo().getScale('adjustablePowerLoad')
			this.value = scale.getCurrentValue();
			this.unit = scale.getUnit();
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_ADJUSTABLE_POWER_LOAD_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.AdjustableLoadProgramStart;

				if (diff <= 1000) {
					t.ioService.deviceInfo().setBurner('active');
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.AdjustableLoadProgramState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.AdjustableLoadProgramStart;
				Programs.AdjustableLoadProgramStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						t.ioService.deviceInfo().setBurner('inactive');
						Programs.AdjustableLoadProgramState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}


	static MaxEingestBelastungProgrammStart: number;
	static MaxEingestBelastungProgrammRuns = 0;
	static MaxEingestBelastungProgrammState = 'stopped';
	static MaxEingestBelastungProgramm(t: any) {
		Programs.MaxEingestBelastungProgrammRuns++;
		console.log("Program running: " + Programs.MaxEingestBelastungProgrammRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.MaxEingestBelastungProgrammState == 'stopped') {
			Programs.MaxEingestBelastungProgrammState = 'running';
			let date = new Date();
			Programs.MaxEingestBelastungProgrammStart = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'P.03 ' + this.translator.tr('DELIGHT_TEST_PROGRAM_HEATING_LOAD');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let scale = this.ioService.getDeviceInfo().getScale('maxHeatLoad');
			this.value = scale.getCurrentValue();
			this.unit = scale.getUnit();
			if (idx == 0) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_HEATING_LOAD_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.MaxEingestBelastungProgrammStart;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING') + "...";
				}
				if (diff > 1000 && diff < duration) {
					t.ioService.deviceInfo().setBurner('active');
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}


				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING') + "...";

				}
				Programs.MaxEingestBelastungProgrammState = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_FINISHED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.MaxEingestBelastungProgrammStart;
				Programs.MaxEingestBelastungProgrammStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						t.ioService.deviceInfo().setBurner('inactive');
						Programs.MaxEingestBelastungProgrammState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_07Start: number;
	static actuatortest_07Runs = 0;
	static actuatortest_07State = 'stopped';
	static actuatortest_07(t: any) {
		Programs.actuatortest_07Runs++;
		console.log("Program running: " + Programs.actuatortest_07Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_07State == 'stopped') {
			Programs.actuatortest_07State = 'running';
			let date = new Date();
			Programs.actuatortest_07Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.07 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_MIN_MODULATION');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let scale = this.ioService.getDeviceInfo().getScale('burnerMinModulation');

			this.value = scale.getCurrentValue();
			if (!this.value) {
				this.value = "0";
			}
			this.unit = scale.getUnit();


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_BURNER_ON_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_07Start;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					//return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_07State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_07Start;
				Programs.actuatortest_07Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_07State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}

	static actuatortest_06Start: number;
	static actuatortest_06Runs = 0;
	static actuatortest_06State = 'stopped';
	static actuatortest_06(t: any) {
		Programs.actuatortest_06Runs++;
		console.log("Program running: " + Programs.actuatortest_06Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_06State == 'stopped') {
			Programs.actuatortest_06State = 'running';
			let date = new Date();
			Programs.actuatortest_06Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.06 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_EXTERNAL_PUMP');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';

			this.unit = "";


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_EXTERNAL_PUMP_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_06Start;

				if (diff <= 1000) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_ON');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_06State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_06Start;
				Programs.actuatortest_06Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_06State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static actuatortest_05Start: number;
	static actuatortest_05Runs = 0;
	static actuatortest_05State = 'stopped';
	static actuatortest_05(t: any) {
		Programs.actuatortest_05Runs++;
		console.log("Program running: " + Programs.actuatortest_05Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_05State == 'stopped') {
			Programs.actuatortest_05State = 'running';
			let date = new Date();
			Programs.actuatortest_05Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.05 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_CIRCULATION_PUMP');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.unit = "";


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_CIRCULATION_PUMP_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_05Start;

				if (diff <= 1000) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_ON');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_05State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_05Start;
				Programs.actuatortest_05Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_05State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_04Start: number;
	static actuatortest_04Runs = 0;
	static actuatortest_04State = 'stopped';
	static actuatortest_04(t: any) {
		Programs.actuatortest_04Runs++;
		console.log("Program running: " + Programs.actuatortest_04Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_04State == 'stopped') {
			Programs.actuatortest_04State = 'running';
			let date = new Date();
			Programs.actuatortest_04Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.04 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_TANK_LOAD_PUMP');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';

			this.unit = "";


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_TANK_LOAD_PUMP_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_04Start;

				if (diff <= 1000) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_ON');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					this.value = this.translator.tr('ENUM_ACTUATION_REVERSAL_OFF');
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_04State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_04Start;
				Programs.actuatortest_04Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_04State = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_03Start: number;
	static actuatortest_03Runs = 0;
	static actuatortest_03State = 'stopped';
	static actuatortest_03(t: any) {
		Programs.actuatortest_03Runs++;
		console.log("Program running: " + Programs.actuatortest_03Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		let initialValue = t.ioService.getDeviceInfo().getScale('fanSpeed').getCurrentValue();
		t.ioService.getDeviceInfo().getScale('fanSpeed').setCurrentValue(14);
		if (Programs.actuatortest_03State == 'stopped') {
			Programs.actuatortest_03State = 'running';
			let date = new Date();
			Programs.actuatortest_03Start = parseInt("" + date.getTime());
		}

		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.03 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_FAN');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let scale = this.ioService.getDeviceInfo().getScale('fanSpeed');

			this.value = scale.getCurrentElement();
			if (!this.value) {
				this.value = "0";
			}
			this.unit = scale.getUnit();


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_FAN_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_03Start;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_03State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === 'up' || evt == 'panup') {
				this.ioService.getDeviceInfo().getScale('fanSpeed').increase(true);
				return;
			}
			if (evt === 'down' || evt == 'pandown') {
				this.ioService.getDeviceInfo().getScale('fanSpeed').decrease(true);
				return;
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_03Start;
				Programs.actuatortest_03Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_03State = 'stopped';
						eH.call(t, 'back');
						this.ioService.getDeviceInfo().getScale('fanSpeed').setCurrentValue(initialValue);
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}

	static actuatortest_02Start: number;
	static actuatortest_02Runs = 0;
	static actuatortest_02State = 'stopped';
	static actuatortest_02(t: any) {
		Programs.actuatortest_02Runs++;
		console.log("Program running: " + Programs.actuatortest_02Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_02State == 'stopped') {
			Programs.actuatortest_02State = 'running';
			let date = new Date();
			Programs.actuatortest_02Start = parseInt("" + date.getTime());
		}

		let initialValue = t.ioService.getDeviceInfo().getScale('threewayValveState').getCurrentValue();
		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.01 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_DIVERTER_VALVE');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			this.value = this.ioService.getDeviceInfo().getScale('threewayValveState').toString();

			this.unit = "";


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_DIVERTER_VALVE_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_02Start;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}
				if (diff > 1000 && diff < duration) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_02State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === 'up' || evt == 'panup') {
				this.ioService.getDeviceInfo().getScale('threewayValveState').increase(true);
				return;
			}
			if (evt === 'down' || evt == 'pandown') {
				this.ioService.getDeviceInfo().getScale('threewayValveState').decrease(true);
				return;
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_02Start;
				Programs.actuatortest_02Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_02State = 'stopped';
						eH.call(t, 'back');
						this.ioService.getDeviceInfo().getScale('threewayValveState').setCurrentValue(initialValue);
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static actuatortest_01Start: number;
	static actuatortest_01Runs = 0;
	static actuatortest_01State = 'stopped';
	static actuatortest_01(t: any) {
		Programs.actuatortest_01Runs++;
		console.log("Program running: " + Programs.actuatortest_01Runs);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.actuatortest_01State == 'stopped') {
			Programs.actuatortest_01State = 'running';
			let date = new Date();
			Programs.actuatortest_01Start = parseInt("" + date.getTime());
		}
		let initialValue = t.ioService.getDeviceInfo().getScale('internalPump').getCurrentValue();
		let duration = 15 * 60 * 1000;
		t.getText = function (idx: number) {
			t.title = 'T.01 ' + this.translator.tr('DELIGHT_ACTUATOR_TEST_INTERNAL_PUMP');
			this.showIconBar = true;
			this.menuIcon = 'iconInstallerGrey';
			let scale = this.ioService.getDeviceInfo().getScale('internalPump');
			this.value = scale.getCurrentValue();
			this.unit = scale.getUnit();


			if (idx == 0) {
				return this.translator.tr('DELIGHT_ACTUATOR_TEST_INTERNAL_PUMP_DESCRIPTION');
			}
			if (idx == 2) {
				return this.translator.tr('DELIGHT_TEST_PROGRAM_PRESS_TO_CANCEL');
			}
			if (idx == 1) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.actuatortest_01Start;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > 1000 && diff < duration) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_RUNNING');
					//return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER')+' '+Helper.minutesAndSeconds(parseInt(""+(duration-diff)/1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');

				}
				Programs.actuatortest_01State = 'stopped';
				return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST') + " " + this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			console.log("Handling event: " + evt);

			if (evt === 'up' || evt == 'panup') {
				this.ioService.getDeviceInfo().getScale('internalPump').increase(true);
				return;
			}
			if (evt === 'down' || evt == 'pandown') {
				this.ioService.getDeviceInfo().getScale('internalPump').decrease(true);
				return;
			}
			if (evt == 'confirm') {
				return;
			}
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.actuatortest_01Start;
				Programs.actuatortest_01Start -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.actuatortest_01State = 'stopped';
						eH.call(t, 'back');
						console.log("initialValue:" + initialValue);
						this.ioService.getDeviceInfo().getScale('internalPump').setCurrentValue(initialValue);
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}




	static hydraulicBalanceStart: number;
	static hydraulicBalanceRuns = 0;
	static hydraulicBalanceState = 'stopped';
	static hydraulicBalance(t: any) {
		Programs.hydraulicBalanceRuns++;
		console.log("Program running: " + Programs.hydraulicBalanceRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.hydraulicBalanceState == 'stopped') {
			Programs.hydraulicBalanceState = 'running';
			let date = new Date();
			Programs.hydraulicBalanceStart = parseInt("" + date.getTime());
		}

		let duration = 6 * 60 * 1000;
		t.getText = function (idx: number) {

			this.dashIcon = 'iconMobile';
			this.menuIcon = 'iconInstallerGrey';
			this.value = "";
			this.unit = "";


			if (idx == 2) {

				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.hydraulicBalanceStart;

				if (diff <= 1000) {
					//return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff < duration) {
					return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
				}
				if (diff >= duration && (diff - 1000) <= (duration)) {
					//return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
				}
				Programs.hydraulicBalanceState = 'stopped';
				//return this.translator.tr('DELIGHT_TEST_MODE_ACTUATOR_TEST')+" "+this.translator.tr('DELIGHT_TEST_MODE_STOPPED');

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt === 'question') {
				MenuNode.ioService.historyPush(t.currentNode);
				t.menuService.goto('data_overview_list_animation');
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.hydraulicBalanceStart;
				Programs.hydraulicBalanceStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.hydraulicBalanceState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}









	static WaterFillStart: number;
	static WaterFillRuns = 0;
	static WaterFillState = 'stopped';
	static WaterFill(t: any) {
		Programs.WaterFillRuns++;
		console.log("Program running: " + Programs.WaterFillRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.WaterFillState == 'stopped') {
			Programs.WaterFillState = 'running';
			let date = new Date();
			Programs.WaterFillStart = parseInt("" + date.getTime());
		}

		let duration = 5 * 1000;
		t.getText = function (idx: number) {
			if (idx == 0) {
				let d = new Date();
				let diff = parseInt("" + d.getTime()) - Programs.WaterFillStart;

				if (diff <= 1000) {
					return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_STARTING');
				}

				if (diff > duration) {
					this.node.addButton('confirm');
					Programs.WaterFillState = 'done';
					return this.translator.tr('DELIGHT_INSTALLATION_ASSISTANT_EXPLANATION');
				}

			} else {
				return getText.call(t, idx);
			}
		}
		t.eventHandler = function (evt) {
			if (evt == 'confirm') {
				if (Programs.WaterFillState == 'done') {
					Programs.WaterFillState = 'terminating';
					t.getText = function (idx: number) {
						return this.translator.tr('DELIGHT_TEST_MODE_TEST_PROGRAM') + " " + this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
					}
					setTimeout(
						() => {
							Programs.WaterFillState = 'stopped';
							t.eventHandler = eH;
							t.getText = getText;
							this.node.removeButton('confirm');
							let target = this.node.getTargetNode();
							if (target) {
								this.menuService.goto(target);
								return;
							}
						}, 3000);
					return;
				}
				if (Programs.WaterFillState == 'terminating') {
					t.getText = (idx) => {
						return this.translator.tr('DELIGHT_TEST_MODE_TERMINATING');
					}
					return;
				}
				if (Programs.WaterFillState == 'stopped') {

				}
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.WaterFillStart;
				Programs.WaterFillStart -= (duration - diff);
				t.eventHandler = eH;
				setTimeout(
					() => {
						Programs.WaterFillState = 'stopped';
						eH.call(t, 'back');
					},
					2000
				);
			} else {
				eH.call(t, evt);
			}
		}
	}



	static qrCodeStart: number;
	static qrCodeRuns = 0;
	static qrCodeState = 'stopped';
	static qrCode(t: any) {
		Programs.qrCodeRuns++;
		console.log("Program running: " + Programs.qrCodeRuns);
		let getText = t.getText;
		let eH = t.eventHandler;
		let gT = t.getTitle;
		if (Programs.qrCodeState == 'stopped') {
			Programs.qrCodeState = 'running';

			Programs.qrCodeStart = parseInt("" + (new Date()).getTime());
		}

		let duration = 30 * 1000;

		t.getText = function (idx: number) {
			this.menuIcon = 'qrCode';
			let d = new Date();
			let diff = parseInt("" + d.getTime()) - Programs.qrCodeStart;

			if (diff > duration) {
				Programs.qrCodeState = 'done';
				eH.call(t, 'back');
				return;
			}
			if (diff > duration - 1000) {
				Programs.qrCodeStart = parseInt("" + (new Date()).getTime());
			}

			if (idx == 0) {
				return "";

			}
			if (idx == 2) {
				return this.translator.tr('AICI_JOKER_REMAINING_TIME_CENTER') + ' ' + Helper.minutesAndSeconds(parseInt("" + (duration - diff) / 1000));
			} else {
				return getText.call(t, idx);
			}

		}
		t.eventHandler = function (evt) {

			if (evt === 'question') {

				let target = t.currentNode.findFromRoot('data_overview_list')
				target.setTemporaryBackTarget(t.currentNode);
				t.menuService.goto('data_overview_list_animation');

				//MenuNode.ioService.historyPush(t.currentNode);
				return;
			}
			if (evt === "back") {
				let d = new Date();
				let diff = d.getTime() - Programs.qrCodeStart;
				//Programs.qrCodeStart -= (duration - diff);

				setTimeout(
					() => {
						Programs.qrCodeState = 'stopped';
						eH.call(t, 'back');
						t.eventHandler = eH;
					},
					500
				);
				return;
			} else {
				eH.call(t, evt);
			}
		}
	}



}